// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_formLogin__en7KN {
    padding: 40px 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
}

.Login_formLogin__en7KN>div {
    width: 100%;
}

.Login_sectionW__oiaCT{
    width: 100%;
}

.Login_formLoginBtns__dej2h {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 24px;
}

.Login_formLoginBtn__ABNuc,
.Login_formLoginBtnActive__pAcWb {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 16px 8px;
    gap: 8px;
    border-radius: var(--radius-global);
}

.Login_formLoginBtn__ABNuc {
    background: var(--color-neutral-300);
    border: 1px solid var(--color-neutral-500);
    color: var(--color-neutral-900) !important;
}


.Login_formLoginBtnActive__pAcWb {
    background: var(--color-primary) !important;
    color: var(--color-white) !important;
}

@media screen and (min-width: 768px) {

    .Login_formLoginBtnActive__pAcWb {
        width: 60%;
    }

    .Login_formLoginBtn__ABNuc {
        width: calc(40% - 8px);
    }
}

@media screen and (min-width: 992px) {

    .Login_sectionW__oiaCT{
        width: calc(50% - 8px) !important;
    }
}

.Login_timerFarme__3nB2u{
    position: relative;
    width: 100%;
    height: 16px;
    border: 1px solid var(--color-neutral-900);
    background-color: var(--color-neutral-000);
    border-radius: var(--radius-global);
    direction: ltr;
}

.Login_timer__4tayl{
    width: 0%;
    height: 100%;
    background-color: var(--color-primary);
    border-radius: var(--radius-global);
    transition: width 0.01s
}

.Login_messageBox__iqsqe{
    width: 100%;
    display: flex;
    gap: 16px;
    background-color: var(--color-neutral-200);
    color: var(--color-neutral-900);
    border: 1px solid var(--color-neutral-500);
    border-radius: var(--radius-global);
    padding: 16px;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Authentication/Login.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,QAAQ;IACR,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;IACpC,0CAA0C;IAC1C,0CAA0C;AAC9C;;;AAGA;IACI,2CAA2C;IAC3C,oCAAoC;AACxC;;AAEA;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;;IAEI;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,0CAA0C;IAC1C,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,sCAAsC;IACtC,mCAAmC;IACnC;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,0CAA0C;IAC1C,+BAA+B;IAC/B,0CAA0C;IAC1C,mCAAmC;IACnC,aAAa;AACjB","sourcesContent":[".formLogin {\n    padding: 40px 16px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 16px;\n}\n\n.formLogin>div {\n    width: 100%;\n}\n\n.sectionW{\n    width: 100%;\n}\n\n.formLoginBtns {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 24px;\n}\n\n.formLoginBtn,\n.formLoginBtnActive {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 16px 8px;\n    gap: 8px;\n    border-radius: var(--radius-global);\n}\n\n.formLoginBtn {\n    background: var(--color-neutral-300);\n    border: 1px solid var(--color-neutral-500);\n    color: var(--color-neutral-900) !important;\n}\n\n\n.formLoginBtnActive {\n    background: var(--color-primary) !important;\n    color: var(--color-white) !important;\n}\n\n@media screen and (min-width: 768px) {\n\n    .formLoginBtnActive {\n        width: 60%;\n    }\n\n    .formLoginBtn {\n        width: calc(40% - 8px);\n    }\n}\n\n@media screen and (min-width: 992px) {\n\n    .sectionW{\n        width: calc(50% - 8px) !important;\n    }\n}\n\n.timerFarme{\n    position: relative;\n    width: 100%;\n    height: 16px;\n    border: 1px solid var(--color-neutral-900);\n    background-color: var(--color-neutral-000);\n    border-radius: var(--radius-global);\n    direction: ltr;\n}\n\n.timer{\n    width: 0%;\n    height: 100%;\n    background-color: var(--color-primary);\n    border-radius: var(--radius-global);\n    transition: width 0.01s,\n}\n\n.messageBox{\n    width: 100%;\n    display: flex;\n    gap: 16px;\n    background-color: var(--color-neutral-200);\n    color: var(--color-neutral-900);\n    border: 1px solid var(--color-neutral-500);\n    border-radius: var(--radius-global);\n    padding: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formLogin": `Login_formLogin__en7KN`,
	"sectionW": `Login_sectionW__oiaCT`,
	"formLoginBtns": `Login_formLoginBtns__dej2h`,
	"formLoginBtn": `Login_formLoginBtn__ABNuc`,
	"formLoginBtnActive": `Login_formLoginBtnActive__pAcWb`,
	"timerFarme": `Login_timerFarme__3nB2u`,
	"timer": `Login_timer__4tayl`,
	"messageBox": `Login_messageBox__iqsqe`
};
export default ___CSS_LOADER_EXPORT___;
